// This is the original minified version of the script
// const tbiUrl="https://beta.tbibank.support/api/RegisterBasket",reseller_code="02S4",reseller_key="chairprobg",Visible_Max=3e4,Visible_Min=100;let callbackExecuted=!1,cartButtonCreated=!1;const delayedCallback=delay(myCallback,500);function delay(callback,delayTime){var timeoutId=0;return function(){var context=this,args=arguments;clearTimeout(timeoutId),timeoutId=setTimeout(function(){callback.apply(context,args),callbackExecuted=!0},delayTime||0)}}function myCallback(){let buyButtonsElement=document.querySelector(".buy-buttons"),footerElement=document.querySelector("footer"),popupContainer=document.createElement("div");popupContainer.setAttribute("id","tbi_popup_container"),popupContainer.innerHTML='<div id="iframe_container"><iframe id="tbi_popup_iframe" src="" scrolling="auto" frameborder="0" width="200" height="200"></iframe><img src="https://cdn.tbibank.support/integrations/loading.svg" id="tbi_loading" width="200" height="200" style="display: none;"></div>',insertAfter(footerElement,popupContainer);let iframeContainer=document.getElementById("iframe_container"),popupContainerElement=document.getElementById("tbi_popup_container");if(iframeContainer.addEventListener("click",event=>{event.stopPropagation()}),window.addEventListener("click",event=>{popupContainerElement.style.display="none",document.body.style.overflow="auto"}),window.addEventListener("message",function(event){if("https://beta.tbibank.support"===event.origin)try{"close"===JSON.parse(event.data).command&&(popupContainerElement.style.display="none",document.body.style.overflow="auto")}catch(error){console.error("Invalid JSON string:",error)}}),null!=buyButtonsElement){let currentProduct=scrapeProduct();if(currentProduct[0].price,currentProduct[0].qty,null==document.getElementById("tbi_button")){let tbiButton=document.createElement("a");tbiButton.classList.add("hidden"),tbiButton.setAttribute("id","tbi_button"),tbiButton.innerHTML='Купете на изплащане с TBI <img src="https://cdn.tbibank.support/logo/tbi-bank-white.svg" class="tbi_button_logo">',insertAfter(buyButtonsElement,tbiButton),document.querySelector(".shopify-section--main-product")?.addEventListener("click",clickEvent=>{let buttonElement=document.getElementById("tbi_button"),productData=scrapeProduct(),totalPrice=productData[0].price*productData[0].qty;buttonElement.style.display=totalPrice>3e4||totalPrice<100?"none":"flex",(productData[0].price!=currentProduct[0].price||productData[0].qty!=currentProduct[0].qty||productData[0].name!=currentProduct[0].name)&&(currentProduct=productData,document.getElementById("tbi_popup_iframe").src="")}),tbiButton.addEventListener("click",clickEvent=>{clickEvent.stopPropagation();let popupElement=document.getElementById("tbi_popup_container"),loadingElement=document.getElementById("tbi_loading");document.getElementById("tbi_popup_iframe"),popupElement.style.display="flex",loadingElement.style.display="flex",postData(tbiUrl,{reseller_code:"02S4",reseller_key:"chairprobg",items:scrapeProduct()})})}else{let existingTbiButton=document.getElementById("tbi_button");document.querySelector(".shopify-section--main-product")?.addEventListener("click",clickEvent=>{let buttonElement=document.getElementById("tbi_button"),productData=scrapeProduct(),totalPrice=productData[0].price*productData[0].qty;buttonElement.style.display=totalPrice>3e4||totalPrice<100?"none":"flex",(productData[0].price!=currentProduct[0].price||productData[0].qty!=currentProduct[0].qty||productData[0].name!=currentProduct[0].name)&&(currentProduct=productData,document.getElementById("tbi_popup_iframe").src="")}),existingTbiButton.addEventListener("click",clickEvent=>{clickEvent.stopPropagation();let popupElement=document.getElementById("tbi_popup_container"),loadingElement=document.getElementById("tbi_loading");document.getElementById("tbi_popup_iframe"),popupElement.style.display="flex",loadingElement.style.display="flex",postData(tbiUrl,{reseller_code:"02S4",reseller_key:"chairprobg",items:scrapeProduct()})})}}let cartTbiWrapper=document.querySelector(".cart-drawer-tbi-wrapper"),cartButton;null==document.getElementById("tbi_cart_button")?((cartButton=document.createElement("a")).setAttribute("id","tbi_cart_button"),cartButton.innerHTML='Купете на изплащане с TBI <img src="https://cdn.tbibank.support/logo/tbi-bank-white.svg" class="tbi_button_logo">',insertAfter(cartTbiWrapper,cartButton)):cartButton=document.getElementById("tbi_cart_button"),document.querySelector(".cart-drawer-total-value")?.textContent.trim().split(" ")[0];document.querySelector(".cart-drawer")&&document.addEventListener("click",clickEvent=>{document.getElementById("tbi_popup_iframe").src="",document.querySelector(".cart-drawer-total-value")?.textContent.trim().split(" ")[0]}),cartButton.addEventListener("click",triggerScrapeCart)}function scrapeProduct(){let productItems=[],productObject={},productTitle=document.querySelector(".product-info__title.h2")?.textContent.trim(),variantInfo=document.querySelector(".variant-picker__option-info variant-option-value");variantInfo=variantInfo?" ("+variantInfo.textContent.trim()+")":"";let advancedFeatures=document.querySelector(".product_advanced_features_item_title_variant");advancedFeatures=advancedFeatures?" ("+advancedFeatures.textContent.trim()+")":"",productObject.name=productTitle+" "+variantInfo+" "+advancedFeatures;let productPrice=parseFloat(document.querySelector(".pdp-total-price.custom_product_card_price")?.textContent.trim().split('(')[0].replace(/[^\d.]/g,"")).toFixed(2);productObject.price=productPrice,productObject.qty=document.querySelector(".quantity-selector__input")?.value,productObject.category=0;let productImage=document.querySelector('.product-gallery__media[data-media-type="image"] img')?.getAttribute("src");return productObject.imagelink=productImage,productItems.push(productObject),productItems}function scrapeCart(){let lineItems=document.querySelectorAll("line-item"),cartItems=[];return lineItems.forEach(lineItem=>{let itemTitle=lineItem.querySelector(".custom_line_item_title"),itemPrice=lineItem.querySelector(".custom_product_card_price").lastChild;itemTitle||(itemTitle=lineItem.querySelector(".addon_text_container"),itemPrice=lineItem.querySelector(".addon_price")),itemTitle=itemTitle.textContent.trim(),itemPrice=itemPrice.textContent.trim().replace(",","").split(" ")[0];let quantityInput=lineItem.querySelector(".quantity-input"),itemMedia=lineItem.querySelector(".line-item__media"),itemQuantity=parseInt(quantityInput.value);let imageUrl="";itemMedia&&(imageUrl=itemMedia.src);let cartItem={name:itemTitle,price:itemPrice,qty:itemQuantity,category:0,imagelink:imageUrl};cartItems.push(cartItem)}),cartItems}function triggerScrapeCart(event){event.stopPropagation();let popupElement=document.getElementById("tbi_popup_container"),loadingElement=document.getElementById("tbi_loading");document.getElementById("tbi_popup_iframe"),popupElement.style.display="flex",loadingElement.style.display="flex",postData(tbiUrl,{reseller_code:"02S4",reseller_key:"chairprobg",items:scrapeCart()})}function postData(url,data){return fetch(url,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(data)}).then(response=>response.json()).then(responseData=>{document.getElementById("tbi_popup_iframe").src=responseData.url,document.getElementById("tbi_loading").style.display="none"}).catch(error=>{console.error("Error:",error)})}function insertAfter(referenceNode,newNode){null!=referenceNode&&referenceNode.parentNode.insertBefore(newNode,referenceNode.nextSibling)}setTimeout(()=>{callbackExecuted||myCallback()},1e3),window.addEventListener("DOMContentLoaded",()=>{delayedCallback()});


// This is a refactored version of their script
class TBI_SCRIPT {
    constructor(){
        this.delayedCallback = this.delay(this.myCallback, 500);
        this.TBI_URL = "https://beta.tbibank.support/api/RegisterBasket";
        this.RESSELLER_CODE = "02S4";
        this.RESSELLER_KEY = "chairprobg";
        this.VISIBLE_MAX = 30000;
        this.VISIBLE_MIN = 100;
        this.TBI_BUTTON_INNER_HTML = 'Купете на изплащане с TBI <img src="https://cdn.tbibank.support/logo/tbi-bank-white.svg" class="tbi_button_logo">';
        this.TBI_POPUP_INNER_HTML = '<div id="iframe_container"><iframe id="tbi_popup_iframe" src="" scrolling="auto" frameborder="0" width="200" height="200"></iframe><img src="https://cdn.tbibank.support/integrations/loading.svg" id="tbi_loading" width="200" height="200" style="display: none;"></div>';
        this.TBI_CART_BUTTON_INNER_HTML = 'Купете на изплащане с TBI <img src="https://cdn.tbibank.support/logo/tbi-bank-white.svg" class="tbi_button_logo">';

        this.callbackExecuted = false;

        this.buyButtonsElement = document.querySelector(".buy-buttons");
        this.footerElement = document.querySelector("footer");
        
        // Initialize popup container and iframe container
        this.initializePopupContainer();
        
        this.cartTbiWrapper = document.querySelector(".cart-drawer-tbi-wrapper");
        this.cartButton = document.getElementById("tbi_cart_button") || this.createCartButton();
        this.tbiButton = document.getElementById("tbi_button") || this.createTbiButton();
    }

    delay = (callback, delayTime) => {
        var timeoutId = 0;
        return function () {
            var context = this;
            var args = arguments;
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                callback.apply(context, args);
                this.callbackExecuted = true;
            }, delayTime || 0);
        };
    }


    myCallback = () => {
        // Ensure popup container is properly set up
        if (!this.popupContainer) {
            this.initializePopupContainer();
        }

        const iframeContainer = this.getIframeContainer();
        iframeContainer?.addEventListener("click", (event) => {event.stopPropagation();})
        
        window.addEventListener("message", (event) => {
            if ("https://beta.tbibank.support" === event.origin) {
                try {
                    if(JSON.parse(event.data).command === "close") {
                        if(this.popupContainer) this.popupContainer.style.display = "none";
                        document.body.style.overflow = "auto";
                    }
                } catch (error) {
                    console.error("Invalid JSON string:", error);
                }
            }
        });
        
        if (!this.tbiButton) this.createTbiButton();
        if (!this.cartButton) this.createCartButton();
        
        // Add event listeners if they don't already exist
        if (this.tbiButton && !this.tbiButton.hasAttribute('data-listener-added')) {
            this.tbiButton.addEventListener("click", (clickEvent) => {
                clickEvent.stopPropagation();
                if(this.popupContainer) this.popupContainer.style.display = "flex";
                const loadingElement = iframeContainer?.querySelector("#tbi_loading");
                if(loadingElement) loadingElement.style.display = "flex";
                this.postData(this.TBI_URL, { reseller_code: this.RESSELLER_CODE, reseller_key: this.RESSELLER_KEY, items: [this.scrapeProduct(clickEvent)] });
            });
            this.tbiButton.setAttribute('data-listener-added', 'true');
        }

        if (this.cartButton && !this.cartButton.hasAttribute('data-listener-added')) {
            this.cartButton.addEventListener("click", this.triggerScrapeCart);
            this.cartButton.setAttribute('data-listener-added', 'true');
        }
    }

    createCartButton = () => {
        const cartButton = document.createElement("a");
        cartButton.setAttribute("id", "tbi_cart_button");
        cartButton.innerHTML = this.TBI_CART_BUTTON_INNER_HTML;
        this.insertAfter(this.cartTbiWrapper, cartButton);
        this.cartButton = cartButton;
    }

    createTbiButton = () => {
        const tbiButton = document.createElement("a");
        tbiButton.classList.add("hidden"),
        tbiButton.setAttribute("id", "tbi_button"),
        tbiButton.innerHTML = this.TBI_BUTTON_INNER_HTML,

        this.insertAfter(this.buyButtonsElement, tbiButton);

        tbiButton.addEventListener("click", (clickEvent) => {
            clickEvent.stopPropagation();
            this.popupContainer.style.display = "flex";
            const iframeContainer = this.getIframeContainer();
            if(iframeContainer) iframeContainer.style.display = "flex";
            this.postData(this.TBI_URL, { reseller_code: this.RESSELLER_CODE, reseller_key: this.RESSELLER_KEY, items: [this.scrapeProduct(clickEvent)] });
        });
        return tbiButton;
    }

    initializePopupContainer = () => {
        this.popupContainer = document.getElementById("tbi_popup_container");
        
        if (!this.popupContainer) {
            this.popupContainer = this.createPopupContainer();
        }
        
        // Ensure iframe container is properly referenced
        this.iframeContainer = document.getElementById("iframe_container");
        
        // Add click handler to close popup
        this.popupContainer.addEventListener("click", (event) => {
            event.stopPropagation();
            this.popupContainer.style.display = "none";
            const iframe = this.getIframeContainer()?.querySelector("#tbi_popup_iframe");
            if(iframe) iframe.src = "";
        });
    }

    getIframeContainer = () => {
        return this.iframeContainer || document.getElementById("iframe_container");
    }

    createPopupContainer = () => {
        const popupContainer = document.createElement("div");
        popupContainer.setAttribute("id", "tbi_popup_container");
        popupContainer.innerHTML = this.TBI_POPUP_INNER_HTML;
        this.insertAfter(this.footerElement, popupContainer);
        
        // Immediately set the iframe container reference after creating the popup
        this.iframeContainer = document.getElementById("iframe_container");

        return popupContainer;
    }

    scrapeProduct = (event) => {
        try{
            let productObject = {}
            const target = event?.target;
            if(!target) return;

            const parentCoordinator = target.closest('[data-product-store]');
            const mainProductId = parentCoordinator.dataset.productId;
            const gallery = parentCoordinator.querySelector('product-gallery');

            const data = window.productStore.getProduct(mainProductId);
            const totalPrice = data.totalPrice;
            // get the last quantity-input value
            const qty = [...parentCoordinator.querySelectorAll('buy-buttons-refactor>quantity-selector>quantity-input')]?.pop()?.value || 1;
            const imagelink = gallery?.querySelector('.product-gallery__media img')?.src;
            const category = 0

            productObject = {
                name: data.title,
                price: totalPrice,
                qty: qty,
                category: category,
                imagelink: imagelink
            }
            return productObject;
        }
        catch(e){
            console.error('TBI ERROR', e);
            const name = document.querySelector('product-info__title').textContent;
            const price = document.querySelector("[data-product-price-info] [data-price]").textContent;
            const qty = document.querySelector("[data-product-price-info] [data-qty]").textContent;
            const imagelink = document.querySelector(".product-gallery__media.is-selected img")?.src;
            const category = 0;

            return {
                name,
                price,
                qty,
                category,
                imagelink
            }
        }
    }

    getDirectText = (element) => {
        const directText = [...element.childNodes]
        .filter(node => node.nodeType === Node.TEXT_NODE)
        .map(node => node.nodeValue.trim())
        .join(" ");
        return directText;
    }

    scrapeCart = () => {
        const cartItems = [];
        const lineItems = document.querySelectorAll("line-item");
        lineItems.forEach((lineItem) => {
            const nameElement = lineItem.querySelector(".custom_line_item_title");
            const name = this.getDirectText(nameElement);

            const priceElement = lineItem.querySelector(".custom_product_card_price span[data-price-value]");
            const price = this.getDirectText(priceElement).replace(/\D/g, "");

            const qty = lineItem.querySelector(".quantity-input-wrapper input.quantity-input")?.value || 1;
            const category = 0;
            const imagelink = lineItem.querySelector(".line-item__media")?.src;

            const lineItemProduct = {
                name,
                price,
                qty,
                category,
                imagelink
            }

            cartItems.push(lineItemProduct);
        });

        return cartItems;
    }

    triggerScrapeCart = (event) => {
        event.stopPropagation();
        if(this.popupContainer) this.popupContainer.style.display = "flex";
        const loadingElement = this.getIframeContainer()?.querySelector("#tbi_loading");
        if(loadingElement) loadingElement.style.display = "flex";

        this.postData(this.TBI_URL, { reseller_code: this.RESSELLER_CODE, reseller_key: this.RESSELLER_KEY, items: this.scrapeCart() });
    }

    postData = (url, data) => {
        return fetch(url, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
            .then((response) => response.json())
            .then((responseData) => {
                const iframeContainer = this.getIframeContainer();
                const iframe = iframeContainer?.querySelector("#tbi_popup_iframe");
                const loadingElement = iframeContainer?.querySelector("#tbi_loading");
                
                if(iframe) {
                    iframe.src = responseData.url;
                }
                
                if(loadingElement) {
                    loadingElement.style.display = "none";
                }
            })
            .catch((error) => {
                console.error("TBI Post Error:", error);
            });
    }

    insertAfter = (referenceNode, newNode) => {
        if(referenceNode) referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
    }

    init = () => {
        setTimeout(() => {this.callbackExecuted || this.myCallback();}, 1000);
        window.addEventListener("DOMContentLoaded", () => {this.delayedCallback();});
    }
}

(new TBI_SCRIPT()).init();